import React, { useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { setAuthenticated } from "../../Reducer/AuthReducer";
import "../Nav/Navbar.css";
import logo from "../../Assets/Icons/IYVAULT LOGO WEB.png";
import { getClientConfig } from "../../config/clientConfig";
import { Button } from "antd";
import ResetPasswordModal from "../../Components/ResetPassword/Resetpassword";

interface User {
  userId: string;
  firstName: string;
  email: string;
}

interface HeaderProps {
  collapsed: boolean;
  clientLogo: any;
}

const Header: React.FC<HeaderProps> = ({ collapsed }) => {
  const clientConfig = getClientConfig();
  const [user, setUser] = useState<User | null>(null);
  const dispatch = useDispatch();

  const [showLogout, setShowLogout] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const logoutRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const userData = localStorage.getItem("user");
    if (userData) setUser(JSON.parse(userData));
  }, []);

  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    dispatch(setAuthenticated(false));
    if ("caches" in window) {
      caches.keys().then((names) => names.forEach((name) => caches.delete(name)));
    }
    window.location.href = "/login";
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (showModal) return;
      if (logoutRef.current && !logoutRef.current.contains(event.target as Node)) {
        setShowLogout(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showModal]);

  return (
    <div
      className={`app-header ${
        collapsed
          ? "app-header--sidebar-collapsed"
          : "app-header--sidebar-expanded"
      }`}
    >
      <img
        src={clientConfig.logo_format_2 || logo}
        alt="Logo"
        className="app-header__logo"
      />

      <div
        className="app-header__user"
        ref={logoutRef}
        onClick={() => setShowLogout(!showLogout)}
      >
        <div>
          <p className="app-header__email">
            {user?.email || "default@gmail.com"}
          </p>
        </div>

        <div className="app-header__avatar">
          {user?.firstName ? user.firstName[0] : "D"}
        </div>

        {showLogout && !showModal && (
          <div className="logoutdiv">
            <button onClick={handleLogout} className="button-style">
              Log Out
            </button>

            <Button
              type="link"
              onClick={() => {
                setShowModal(true);
                setShowLogout(false);
              }}
            >
              Reset Password
            </Button>
          </div>
        )}

        <ResetPasswordModal
          visible={showModal}
          onClose={() => setShowModal(false)}
          userId={user?.userId}
        />
      </div>
    </div>
  );
};

export default Header;
